<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/A50z5N/tc-custom/9781681886718.jpg?1707566367724" alt="This image is the cover for the book Around the World Cookbook, American Girl"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Around the World Cookbook, American Girl
      </h1>
      <p class="bookDescription body article font2">
        <b>A passport to international yums. “Excellent recipes that are not dumbed down for children, which means that grown-ups will want to eat them, too.” —<i>The New York Times</i></b><br/><br/>In this fifth cookbook from Williams Sonoma and American Girl, aspiring cooks will expand their culinary knowledge and palate—and discover a world of savory and sweet delicacies like mini meatballs from Sweden; fresh spring rolls from Vietnam; pad thai from Thailand; tikka masala from India; paella from Spain; kiwi and berry pavlovas from New Zealand; sticky toffee pudding from Great Britain, and so much more. <br/><br/>The easy-to-follow recipes are organized by type and span the globe—from France to Brazil, Turkey to Argentina, Italy to India and beyond—giving kid cooks an opportunity to learn how people eat all over the world. An illustrated map with flags, colorful illustrations featuring passports, and party ideas for sharing these worldly recipes with friends round out the collection.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        The Williams-Sonoma Test Kitchen
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Weldon Owen
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7da6b091